import type { ProcessingStatus } from '@/types/phieu-nhap-kho';

/** Flags from GET /phieu-nhap-kho/chi-tiet/{id} driving update UI. */
export interface PhieuNhapKhoEditState {
  can_edit: boolean;
  lock_reason?: string | null;
  is_approved: boolean;
  hoan_thanh: boolean;
  ngay_hoan_thanh: string | null;
  processing_status: ProcessingStatus | null;
}

/** Derived update capabilities per unified API rules. */
export interface PhieuNhapKhoUpdateCapabilities {
  canEditHeaders: boolean;
  canEditChiTiet: boolean;
  /** hoan_thanh or ngay_hoan_thanh set — limited header fields, no chiTiet */
  isCompletedRestriction: boolean;
  lockReason: string | null;
}

export function resolvePhieuNhapKhoUpdateCapabilities(
  state: PhieuNhapKhoEditState | null
): PhieuNhapKhoUpdateCapabilities {
  if (!state) {
    return {
      canEditHeaders: true,
      canEditChiTiet: true,
      isCompletedRestriction: false,
      lockReason: null,
    };
  }

  const isCompletedRestriction =
    Boolean(state.hoan_thanh) || Boolean(state.ngay_hoan_thanh);

  if (!state.can_edit) {
    return {
      canEditHeaders: false,
      canEditChiTiet: false,
      isCompletedRestriction,
      lockReason: state.lock_reason ?? 'Phiếu nhập không thể chỉnh sửa',
    };
  }

  return {
    canEditHeaders: true,
    canEditChiTiet: !isCompletedRestriction,
    isCompletedRestriction,
    lockReason: null,
  };
}
